
import * as Enumerable from 'linq';
import { FormSection } from './form.section';
import { FormQuestionResponseExport, FormResponse, FormResponseExport } from './form.response';


export class FormExportUtility {

    public static getExportResponse(fullResponse: FormResponse): FormResponseExport {

        const { response, template, completed } = fullResponse;

        const exportResponse = {
            id: fullResponse._id,
            name: template?.title,
            templateId: template?._id,
            templateVersion: template?.version,
            completed: completed,
            responses: []
        } as FormResponseExport;

        const getFormQuestionResponses = (pageName: string, templateSection: FormSection, responseSection: any): FormQuestionResponseExport[] => {

            if (!pageName || !templateSection || !responseSection) return [];

            return Enumerable
                .from(Object.keys(responseSection))
                .select(questionName => {

                    const templateQuestion = Enumerable.from(templateSection.fields).firstOrDefault(x => x.name === questionName);
                    const responseQuestion = responseSection[questionName];

                    if (!templateQuestion) return;

                    let safeAnswer: any;

                    switch (templateQuestion.type) {
                        case 'Multiple':
                            safeAnswer = Array.isArray(responseQuestion) ? responseQuestion : [responseQuestion];
                            break;

                        default:
                            safeAnswer = responseQuestion;
                            break;

                    }

                    return {
                        id: `${pageName}.${templateSection.name}.${questionName}`,
                        type: templateQuestion.type,
                        question: templateQuestion.title,
                        answer: safeAnswer
                    } as FormQuestionResponseExport;
                })
                .where(x => x !== null)
                .toArray();
        }

        Enumerable
            .from(Object.keys(response))
            .forEach(pageName => {

                const templatePage = Enumerable.from(template.pages).firstOrDefault(x => x.name === pageName);
                const responsePage = response[pageName];

                if (!templatePage || !responsePage) return;

                Enumerable
                    .from(Object.keys(responsePage))
                    .forEach(sectionName => {

                        const templateSection = Enumerable.from(templatePage.sections).firstOrDefault(x => x.name === sectionName);
                        const responseSection = responsePage[sectionName];

                        if (!templateSection || !responseSection) return;

                        let exportAnswers: FormQuestionResponseExport[];

                        if (templateSection?.options?.repeat) {

                            // We need to do some cool stuff to turn into a field
                            const repeatingSectionAnswer = {
                                id: `${pageName}.${sectionName}`,
                                type: 'repeatingSection',
                                question: '',
                                answer: []
                            }

                            Enumerable
                                .from(responseSection)
                                .forEach(responseSectionRepeat => {
                                    const repeatAnswers = getFormQuestionResponses(pageName, templateSection, responseSectionRepeat);
                                    repeatingSectionAnswer.answer.push(repeatAnswers);
                                });

                            exportAnswers = [repeatingSectionAnswer];

                        } else {
                            exportAnswers = getFormQuestionResponses(pageName, templateSection, responseSection);
                        }

                        if (exportAnswers?.length) {
                            exportResponse.responses = [...exportResponse.responses, ...exportAnswers];
                        }

                    });

            });

        return exportResponse;

    }
}